import { EquipmentItem } from "@/backend/models/equipmentItem";
import { CustomFieldParams, ObjectInstanceData } from "./customFieldTypes";
import { FusaReply } from "./replyTypes";

export interface ObjectCustomFieldParams extends CustomFieldParams {
  objectInstance: ObjectInstanceData
}

export interface EquipmentItemCreateData {
  name: string;
  description: string;
  identifier: string;
  procedureInstanceId: string;
  defaultConfiguration?: ObjectCustomFieldParams;
  category?: INSTRUMENT_CATEGORY;
}

export interface EquipmentItemData extends EquipmentItemCreateData {
  id: string;
  defaultConfiguration: ObjectCustomFieldParams;
}

export enum INSTRUMENT_CATEGORY {
  NONE = '',
  POWER_SUPPLY = 'power_supply',
  MULTIMETER = 'multimeter',
  OSCILLOSCOPE = 'oscilloscope',
  FUNCTION_GENERATOR = 'function_generator',
  LOGIC_ANALYZER = 'logic_analyzer',
  DIGITAL_MULTIMETER = 'digital_multimeter',
  DIGITAL_FUNCTION_GENERATOR = 'digital_function_generator',
  DAQ = 'data_acquisition',
}

export interface EquipmentListResponse extends FusaReply {
  equipment: EquipmentItem[];
}

export interface EquipmentResponse extends FusaReply {
  equipment: EquipmentItem;
}